<template>
  <div class="care_dialog_container">
    <van-dialog v-model="showCareDialog" :show-confirm-button="false">
      <div class="dialog-main">
        <div class="dialog-title hx-flex-c-c hx-flex-j-b">
          <div></div>
          <van-icon name="cross" @click="closeDialog" />
        </div>
        <div class="dialog-content">

          <div class="main_text" >
            对我感兴趣的话，点个关注吧~
          </div>
          <div class="main_btn" >
            <van-button class="btn_care" @click="onclickCare"> 关 注 </van-button>
          </div>

        </div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
export default {
  name: "CareDialogContainer",
  props: {
    showCareDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  computed: {

  },
  mounted() {
    this.$emit('onShowCareDialog', true)
  },
  methods: {
    closeDialog(){
      this.$emit('closeCareDialog', false)
    },
    onclickCare(){
      this.$emit('onclickCare', true)
    }
  },
};
</script>

<style lang="less" scoped>
</style>

<style lang="less">
.care_dialog_container{
  .van-dialog__content{
    width: 100%;
  }
}
.dialog-main {
  padding: 16px 16px 0 16px;
  color: #000;

}
.dialog-content{
  width: 100%;
  float: left;
  padding-bottom: 20px;
}
.dialog-title {
  line-height: 1;
  padding-bottom: 16px;
}
.main_text{
  width: 100%;
  font-size: 15px;
  color: rgb(163, 163, 163);
  padding: 20px 0;
  text-align: center;
  letter-spacing: 1px; /* 设置文字间隔为 2 像素 */
}
.main_btn{
  width: 100%;
  display: flex;
  justify-content: center;
  align-self: center;
}
.btn_care{
  width: 160px !important;
  height: 40px !important;
  background: rgb(233, 52, 35) !important;
  font-size: 14px  !important;
  color: rgb(230, 230, 230)  !important;
  border-radius: 25px  !important;
  border: none;
}
</style>
